module.exports = __webpack_public_path__ + "static/color-gold.ca301c08.png";